import http, {RequestOptions, noContent, unwrap} from "@/api/http";
import {CursorPage, ProductInventoryDto, ProductInventoryInput, ProductSortKeys, ProductSummaryDto} from "@/api/types";

export interface ListProductsParams {
    title?: string;
    /** Admins only; for everyone else the server uses their own partner. */
    partnerId?: number;
    /** Page size, at most 250. */
    first?: number;
    /** The `endCursor` of the previous page. */
    after?: string;
    sort?: ProductSortKeys;
    /** When omitted Shopify's default applies (newest first). */
    reverse?: boolean;
    onlyReviews?: boolean;
    noDeliveryDate?: boolean;
}

/** `GET /api/products` (#17, P; an admin may pass `partnerId`) */
export const listProducts = (params: ListProductsParams = {}, options?: RequestOptions): Promise<CursorPage<ProductSummaryDto>> =>
    http.get<CursorPage<ProductSummaryDto>>("/products", {...options, params}).then(unwrap);

/** `GET /api/products/{id}` (#18, vendor or admin). `id` is the numeric Shopify id, e.g. `"8123"`. */
export const getProduct = (id: string, options?: RequestOptions): Promise<ProductInventoryDto> =>
    http.get<ProductInventoryDto>(`/products/${encodeURIComponent(id)}`, options).then(unwrap);

/**
 * `PUT /api/product-variants/{variantId}/inventory` (#19, vendor or admin). 204. `variantId` is the numeric Shopify
 * id of the variant, e.g. `"4455"`; the server rebuilds the GID. `available` is required when `tracked` is true.
 */
export const updateVariantInventory = (variantId: string, input: ProductInventoryInput, options?: RequestOptions): Promise<void> =>
    http.put(`/product-variants/${encodeURIComponent(variantId)}/inventory`, input, options).then(noContent);
